
<layout>
  <div class="container mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <!-- Page Header: start -->
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="
                text-2xl
                font-light
                leading-7
                text-gray-900
                sm:text-2xl sm:leading-9 sm:truncate
              ">
              Social-Media-Konten 
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4">

          </div>
        </div>
        <!-- Page Header: end -->

        <horizontal-divider />



        <!-- List: start -->
        <ul role="list" class="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">


          <!-- add new account: start -->
          <li class="overflow-hidden rounded-xl border border-gray-200">
            <div class="flex items-center justify-center gap-x-4 border-b border-gray-900/5 bg-white p-6">

              <img @click="setChannel('facebook')" src="/img/facebook-logo.svg" alt="Facebook"
                class="w-14 h-14 p-2 flex-none rounded-lg bg-white object-cover ring-1 cursor-pointer"
                :class="selectedChannel === 'facebook' ? 'ring-brandhelfer-blue opacity-100' : 'opacity-70 ring-gray-100 hover:opacity-100 hover:ring-brandhelfer-blue'" />

              <img @click="setChannel('instagram')" src="/img/instagram-logo.png" alt="Instagram"
                class="w-14 h-14 p-2 flex-none rounded-lg bg-white object-cover ring-1 cursor-pointer"
                :class="selectedChannel === 'instagram' ? 'ring-brandhelfer-blue opacity-100' : 'opacity-70 ring-gray-100 hover:opacity-100 hover:ring-brandhelfer-blue'" />

              <img @click="setChannel('linkedin')" src="/img/linkedin-logo.png" alt="Linkedin"
                class="h-14 p-2 flex-none rounded-lg bg-white object-cover ring-1 cursor-pointer"
                :class="selectedChannel === 'linkedin' ? 'ring-brandhelfer-blue opacity-100' : 'opacity-70 ring-gray-100 hover:opacity-100 hover:ring-brandhelfer-blue'" />

            </div>

            <dl class="bg-gray-50 -my-3 divide-y divide-gray-100 px-6 py-9 text-sm w-full text-center">

              <button @click="createAccount" type="button"
                class="mx-auto relative inline-flex items-center mr-4 px-4 py-2 border border-transparent text-sm rounded-md text-white shadow-sm bg-brandhelfer-blue  focus:outline-none "
                :class="!selectedChannel ? 'opacity-50  cursor-not-allowed' : 'hover:bg-brandhelfer-blue focus:ring-2 focus:ring-offset-2 focus:ring-brandhelfer-blue cursor-pointer'"
                :disabled="!selectedChannel">{{ linkButtonText }}</button>

            </dl>

          </li>
          <!-- add new account: end -->




          <account v-for="account in allSocialAccounts" :key="account.id" :account="account"
          @accountDeleted="deleteAccount"
          ></account>

        </ul>

        <!-- List: end -->
      </div>
    </div>
  </div>

  <confirm-modal v-if="confirmModal.visible" :headline="confirmModal.headline" :text="confirmModal.text"
    @close="confirmModal.visible = false" @confirm="deleteAccountConfirmed"></confirm-modal>
</layout>
